import CustomInput from "components/CustomInput/CustomInput";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import React from "react";



const TopicwiseTestTopics = React.forwardRef((props, ref) => {

  const [pointsPerQuestion, setPointsPerQuestion] = React.useState(
    props.st.pointsPerQuestion
  );
  const [questionsAllowed, setQuestionsAllowed] = React.useState(

  );
  const [IsMandatory, setIsMandatory] = React.useState(0);
  const [scqQCounts, setScqQCounts] = React.useState(0);
  const [numQCounts, setNumQCounts] = React.useState(0);
  const [setCount, setSetCount] = React.useState(1);

  const [questionsAllowedState, setQuestionsAllowedState] = React.useState("");
  const [pointsPerQuestionState, setPointsPerQuestionState] = React.useState("");
  const [scqQCountsState, setScqQCountsState] = React.useState("");
  const [numQCountsState, setNumQCountsState] = React.useState("");
  const [setCountState, setSetCountState] = React.useState("success");

  // consoling state 
  React.useEffect(() => {
    console.log("yo", props);
  }, [props, ref]);

  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
    sendState: () => {
      return sendState();
    },
    state: {
      type: "test",
      //   
      IsMandatory,
      pointsPerQuestion,
      questionsAllowed,
      scqQCounts,
      numQCounts,
      setCount
      // 
    },
  }));
  const sendState = () => {
    return {
      type: "test",
      //
      IsMandatory,
      pointsPerQuestion,
      questionsAllowed,
      scqQCounts,
      numQCounts,
      setCount

      // 
    };
  };
  // start 
  const verifyRange = (value, min, max) => {
    if (!value) return false;

    if (value >= min) {
      return true;
    }
    return false;
  };
  const isValidated = () => {
    if (questionsAllowedState == "success" && pointsPerQuestionState == "success" && scqQCountsState === "success" && numQCountsState === "success" && setCountState == "success") {
      return true;
    } else {
      if (questionsAllowedState !== "success") {
        setQuestionsAllowedState("error");
      }
      if (pointsPerQuestionState !== "success") {
        setPointsPerQuestionState("error")
      }
      if (scqQCountsState !== "success") {
        setScqQCountsState("error");
      }
      if (numQCountsState !== "success") {
        setNumQCountsState("error");
      }
      if (setCountState !== "success") {
        setCountState("error");
      }
    }
    return false;
  };
  // end

  React.useEffect(() => {
    // Ensure scqQCounts + numQCounts equals questionsAllowed
    console.log("counts", questionsAllowed, scqQCounts, numQCounts, (parseInt(scqQCounts) + parseInt(numQCounts) !== parseInt(questionsAllowed)));
    if (parseInt(scqQCounts) + parseInt(numQCounts) !== parseInt(questionsAllowed)) {
      setScqQCountsState("error");
      setNumQCountsState("error");
    } else {
      setScqQCountsState("success");
      setNumQCountsState("success");
    }
  }, [scqQCounts, numQCounts, questionsAllowed]);


  return (
    <div>
      <GridContainer justify="center">
        {/* <GridItem xs={12} sm={12} md={2}>
        </GridItem> */}
        <GridItem xs={12} sm={12} md={4}>
          <small style={{ color: 'red' }}>Note: Questions are allowed, and points are applicable for each topic.</small>
        </GridItem>
        <GridItem xs={12} sm={12} md={7}>
        </GridItem>
      </GridContainer>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={2}>
          <CustomInput
            success={questionsAllowedState === "success"}
            error={questionsAllowedState === "error"}
            labelText={
              <span>
                Questions Allowed <small>(required)</small>
              </span>
            }
            id="questionsAllowed"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: "number",
              onChange: (event) => {
                if (!verifyRange(event.target.value, 1)) {
                  setQuestionsAllowedState("error");
                } else {
                  setQuestionsAllowedState("success");
                }
                setQuestionsAllowed(event.target.value);
              },
              value: questionsAllowed,
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={2}>
          <CustomInput
            success={pointsPerQuestionState == 'success'}
            error={pointsPerQuestionState == 'error'}
            labelText={<span>Points per Question <small>(required)</small></span>}
            id="pointsPerQuestion"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: "number",
              onChange: (event) => {
                if (event.target.value > 0) {
                  setPointsPerQuestionState('success');
                  setPointsPerQuestion(event.target.value);
                } else {
                  setPointsPerQuestionState('error')
                  setPointsPerQuestion('')
                }
              },
              value: pointsPerQuestion,
            }}
          />
        </GridItem>
        {/* <GridItem xs={12} sm={12} md={7}> */}
        {/* <FormControlLabel
                  control={
                  <Switch
                      value={IsMandatory}
                      onChange={(e) => {
                        setIsMandatory(e.target.checked == true ? 1:0);
                      }}
                      checked={IsMandatory}
                  />
                  }
                  label={<small>Mandatory To Pass</small>}
              /> */}
        {/* </GridItem> */}
        <GridItem xs={12} sm={12} md={3}>
          <CustomInput
            success={scqQCountsState === "success"}
            error={scqQCountsState === "error"}
            labelText={<span>SCQ Question Count <small>(required)</small></span>}
            id="scqQCounts"
            formControlProps={{ fullWidth: true }}
            inputProps={{
              type: "number",
              onChange: (event) => {
                setScqQCounts(event.target.value);
              },
              value: scqQCounts,
            }}
          />
        </GridItem>

        <GridItem xs={12} sm={12} md={3}>
          <CustomInput
            success={numQCountsState === "success"}
            error={numQCountsState === "error"}
            labelText={<span>NUMERICAL Question Count <small>(required)</small></span>}
            id="numQCounts"
            formControlProps={{ fullWidth: true }}
            inputProps={{
              type: "number",
              onChange: (event) => {
                setNumQCounts(event.target.value);
              },
              value: numQCounts,
            }}
          />
        </GridItem>
      </GridContainer>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={2} style={{ marginLeft: "80px" }}>
          <CustomInput
            success={setCountState === "success"}
            error={setCountState === "error"}
            labelText={
              <span>
                setCount <small>(required)</small>
              </span>
            }
            id="setCount"
            formControlProps={{
              fullWidth: true,
            }}
            inputProps={{
              type: "number",
              onChange: (event) => {
                if (!verifyRange(event.target.value, 1)) {
                  setSetCountState("error");
                } else {
                  setSetCountState("success");
                }
                setSetCount(event.target.value);
              },
              value: setCount,
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={5}>

        </GridItem>
        <GridItem xs={12} sm={12} md={4}>

        </GridItem>
        {/* <GridItem xs={12} sm={12} md={8}>
        </GridItem> */}
      </GridContainer>

    </div>
  );
});

TopicwiseTestTopics.displayName = "Step3";

export default TopicwiseTestTopics;



